import http from '../utils/http';
import {
  SET_USER,
  CLEAR_USER,
} from '../constants/actionTypes';

import { setFeedbackAction } from './feedback';
import {
  clearFilters,
  setSorting,
} from './jobs';

import {
  userUrl,
  setLanguageUrl,
  setCameraButtonPositionUrl,
} from '../constants/urls';

const setUserAction = userData => ({
  type: SET_USER,
  payload: userData,
});

const clearUserAction = () => ({ type: CLEAR_USER });

export const logout = () =>
  async dispatch => {
    // do logout stuff
    dispatch(clearUserAction());
    dispatch(clearFilters());
    dispatch(setSorting('DESC'));
    localStorage.clear();
}

export const setLanguage = language =>
  async dispatch => {
    try {
      const
        { data: response } = await http.post(setLanguageUrl, { language }),
        user = response.data;

      dispatch(setUserAction(user));
      localStorage.setItem('user', JSON.stringify(user));
      return true;
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
      return false;
    }
}

export const setCameraButtonPosition = cameraButtonPosition =>
  async dispatch => {
    try {
      const
        { data: response } = await http.put(setCameraButtonPositionUrl, { cameraButtonPosition }),
        user = response.data;

      dispatch(setUserAction(user));
      localStorage.setItem('user', JSON.stringify(user));
      return true;
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
      return false;
    }
}

export const getUser = () =>
  async dispatch => {
    try {
      const
        { data: response } = await http.get(userUrl),
        user = response.data;
      dispatch(setUserAction(user));
      localStorage.setItem('user', JSON.stringify(user));
    } catch (e) {
      localStorage.removeItem('user');
      dispatch(clearUserAction());
    }
  }



// WEBPACK FOOTER //
// ./src/actions/authentication.js